import script from "./admin_liveManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./admin_liveManagement.vue?vue&type=script&setup=true&lang=js"

import "./admin_liveManagement.vue?vue&type=style&index=0&id=4a298b01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a298b01"]])

export default __exports__